var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaths(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Maths",
    transform: "translate(21753 -1955)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Maths-2",
    "data-name": "Maths",
    width: 89,
    height: 89,
    rx: 10,
    transform: "translate(-21753 1955)",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6361",
    "data-name": "Group 6361",
    transform: "translate(-30417.822 -5051.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c7c44284-2030-48db-8927-9273f5368542",
    transform: "translate(8689.354 7026.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_95",
    "data-name": "Subtraction 95",
    d: "M34.942,34.937H4.991A5,5,0,0,1,0,29.947V0H39.932V29.947a5,5,0,0,1-4.991,4.991ZM31.2,26.2a1.182,1.182,0,0,0-1.249,1.248v2.494A1.182,1.182,0,0,0,31.2,31.193h3.744a1.183,1.183,0,0,0,1.248-1.247v-2.5A1.182,1.182,0,0,0,34.942,26.2Zm-8.735,0a1.182,1.182,0,0,0-1.248,1.248v2.494a1.182,1.182,0,0,0,1.248,1.248H26.2a1.175,1.175,0,0,0,1.248-1.247v-2.5A1.182,1.182,0,0,0,26.2,26.2Zm-8.731,0a1.182,1.182,0,0,0-1.248,1.248v2.494a1.182,1.182,0,0,0,1.248,1.248h3.74a1.189,1.189,0,0,0,1.252-1.247v-2.5A1.182,1.182,0,0,0,17.476,26.2Zm-8.738,0a1.182,1.182,0,0,0-1.249,1.248v2.494a1.182,1.182,0,0,0,1.249,1.248H8.738a1.181,1.181,0,0,0,1.248-1.247v-2.5A1.182,1.182,0,0,0,8.738,26.2Zm26.2-7.488a1.182,1.182,0,0,0-1.249,1.249v2.5A1.182,1.182,0,0,0,31.2,23.707h3.744a1.183,1.183,0,0,0,1.248-1.248v-2.5a1.182,1.182,0,0,0-1.248-1.249Zm-8.735,0a1.182,1.182,0,0,0-1.248,1.249v2.5a1.182,1.182,0,0,0,1.248,1.248H26.2a1.176,1.176,0,0,0,1.248-1.248v-2.5A1.182,1.182,0,0,0,26.2,18.715Zm-8.731,0a1.182,1.182,0,0,0-1.248,1.249v2.5a1.182,1.182,0,0,0,1.248,1.248h3.74a1.19,1.19,0,0,0,1.252-1.248v-2.5a1.182,1.182,0,0,0-1.249-1.249Zm-8.738,0a1.182,1.182,0,0,0-1.249,1.249v2.5a1.182,1.182,0,0,0,1.249,1.248H8.738a1.182,1.182,0,0,0,1.248-1.248v-2.5a1.182,1.182,0,0,0-1.248-1.249Zm26.2-7.486a1.182,1.182,0,0,0-1.249,1.249v2.491A1.182,1.182,0,0,0,31.2,16.217h3.744a1.182,1.182,0,0,0,1.248-1.245v-2.5a1.182,1.182,0,0,0-1.248-1.249Zm-8.735,0a1.182,1.182,0,0,0-1.248,1.249v2.491a1.182,1.182,0,0,0,1.248,1.249H26.2a1.25,1.25,0,0,0,.911-.344,1.234,1.234,0,0,0,.338-.9v-2.5A1.182,1.182,0,0,0,26.2,11.229Zm-8.731,0a1.182,1.182,0,0,0-1.248,1.249v2.491a1.182,1.182,0,0,0,1.248,1.249h3.74a1.188,1.188,0,0,0,1.252-1.245v-2.5a1.182,1.182,0,0,0-1.249-1.249Zm-8.738,0a1.182,1.182,0,0,0-1.249,1.249v2.491a1.182,1.182,0,0,0,1.249,1.249H8.738a1.18,1.18,0,0,0,1.248-1.245v-2.5a1.182,1.182,0,0,0-1.248-1.249ZM31.2,3.742a1.182,1.182,0,0,0-1.249,1.248V7.485A1.182,1.182,0,0,0,31.2,8.734h3.744A1.183,1.183,0,0,0,36.19,7.486v-2.5a1.182,1.182,0,0,0-1.248-1.248Zm-8.735,0a1.182,1.182,0,0,0-1.248,1.248V7.485a1.182,1.182,0,0,0,1.248,1.249H26.2a1.176,1.176,0,0,0,1.248-1.247v-2.5A1.182,1.182,0,0,0,26.2,3.742Zm-8.731,0a1.182,1.182,0,0,0-1.248,1.248V7.485a1.182,1.182,0,0,0,1.248,1.249h3.74a1.189,1.189,0,0,0,1.252-1.247v-2.5a1.182,1.182,0,0,0-1.249-1.248Zm-8.738,0A1.182,1.182,0,0,0,3.745,4.991V7.485A1.182,1.182,0,0,0,4.994,8.734H8.738A1.181,1.181,0,0,0,9.986,7.486v-2.5A1.182,1.182,0,0,0,8.738,3.742Z",
    transform: "translate(0 14.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_96",
    "data-name": "Subtraction 96",
    d: "M39.932,16.221H0V4.991A5,5,0,0,1,4.991,0H34.939a5,5,0,0,1,4.993,4.991v11.23ZM4.991,3.746A1.182,1.182,0,0,0,3.743,4.995V11.23a1.182,1.182,0,0,0,1.248,1.249H34.939a1.183,1.183,0,0,0,1.248-1.249V4.995a1.182,1.182,0,0,0-1.248-1.248Z",
    transform: "translate(0.003)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4696",
    "data-name": "Rectangle 4696",
    width: 2.495,
    height: 2.495,
    transform: "translate(31.198 7.486)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4697",
    "data-name": "Rectangle 4697",
    width: 2.495,
    height: 2.495,
    transform: "translate(26.207 7.486)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaths);
export default __webpack_public_path__ + "static/media/Maths.ee22b739.svg";
export { ForwardRef as ReactComponent };